const AppointmentStatuses = {
	WAITING: 'new',
	SUCCESS: 'done',
	CANCELLED: 'cancelled',
	FAIL: 'fail',
	PASSED: 'passed',
}

const AppointmentStatusProps = {
	[AppointmentStatuses.WAITING]: {text: '⌛ поиск', bgcolor: '#cccccc'},
	[AppointmentStatuses.SUCCESS]: {text: '✅ выполнен', bgcolor: '#a9eea9'},
	[AppointmentStatuses.CANCELLED]: {text: '❌ отменена', bgcolor: '#eebbbb'},
	[AppointmentStatuses.FAIL]: {text: '❌ не удалось', bgcolor: '#eebbbb'},
	[AppointmentStatuses.PASSED]: {text: 'время прошло', bgcolor: '#eebbbb'},
}

export { AppointmentStatuses, AppointmentStatusProps }
